import { selectTotalCount } from 'app/results/resultsSlice'
import { Fade, Stack, Typography } from '@mui/material'
import { selectIsFiltered } from 'app/selectors'
import useProducts from 'helpers/useProducts'
import { useSelector } from 'react-redux'
import GridItem from '@feature/GridItem'
import { Box } from '@mui/system'

const ResultsCount = () => {
  const totalCount = useSelector(selectTotalCount)
  const isFiltered = useSelector(selectIsFiltered)
  const { products } = useProducts(undefined, !isFiltered)
  const totalAmount = products.length > totalCount ? products.length : totalCount

  return (
    <GridItem>
      <Box p={1} bgcolor={'grey.200'}>
        <Fade in>
          <Stack flexDirection={'row'}>
            <Typography variant={'large'} textAlign={'center'} width={'100%'}>
              Showing { totalAmount } products.
            </Typography>
          </Stack>
        </Fade>
      </Box>
    </GridItem>
  )
}

export default ResultsCount
